class DeliveryCountdown extends HTMLElement {
  constructor() {
    super();
    this.initializeCountdown();
  }

  initializeCountdown() {
    if (this.dataset.targetContainer) {
      const targetContainer = document.querySelector(this.dataset.targetContainer);    
      if (targetContainer) targetContainer.appendChild(this);
    }

    const cutoffHour = parseInt(this.dataset.cutoffHour, 10);
    const cutoffMinute = parseInt(this.dataset.cutoffMinute, 10);
    const leadTimeDays = parseInt(this.dataset.leadTimeDays, 10);
    const excludedDates = this.dataset.excludedDates.split(',').map(date => new Date(date.trim()));

    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const dispatchDays = [1, 2, 3, 4, 5];
    const deliveryDays = [1, 2, 3, 4, 5, 6];

    const countdownElements = {
      hours: this.querySelector('.countdown__hours'),
      minutes: this.querySelector('.countdown__minutes'),
      dispatchDate: this.querySelector('.countdown__dispatch_date'),
      deliveryDay: this.querySelector('.countdown__delivery_day'),
      timeDisplay: this.querySelector('.countdown_time--time'),
      soonDisplay: this.querySelector('.countdown_time--soon'),
      byDisplay: this.querySelector('.countdown_time--by'),
    };

    const ordinalSuffix = num => {
      const suffixes = ["th", "st", "nd", "rd"];
      const v = num % 100;
      return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    };

    const isExcluded = (date, exclusions) => exclusions.some(exDate => exDate.toDateString() === date.toDateString());

    const calculateDeliveryDate = (currentDate, leadDays, validDays, exclusions) => {
      let date = new Date(currentDate);
      let daysAdded = 0;

      while (daysAdded < leadDays) {
        date.setDate(date.getDate() + 1);
        if (validDays.includes(date.getDay()) && !isExcluded(date, exclusions)) {
          daysAdded++;
        }
      }

      return date;
    };

    const updateCountdown = () => {
      const now = new Date();
      const cutoffTime = new Date(now);
    
      cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);
    
      const isBeforeCutoff = now < cutoffTime;
    
      if (!isBeforeCutoff) {
        cutoffTime.setDate(cutoffTime.getDate() + 1);
      }
    
      const leadDays = isBeforeCutoff ? leadTimeDays : leadTimeDays + 1;
    
      const dispatchDate = calculateDeliveryDate(now, 0, dispatchDays, excludedDates);
      const deliveryDate = calculateDeliveryDate(dispatchDate, leadDays, deliveryDays, excludedDates);
    
      const timeDiff = cutoffTime - now;
      const hoursLeft = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutesLeft = Math.floor((timeDiff / (1000 * 60)) % 60);
    
      countdownElements.hours.textContent = hoursLeft;
      countdownElements.minutes.textContent = minutesLeft;
      countdownElements.dispatchDate.textContent = `${dispatchDate.getHours() % 12 || 12}pm ${days[dispatchDate.getDay()]}`;
      countdownElements.deliveryDay.textContent = `${days[deliveryDate.getDay()]} ${ordinalSuffix(deliveryDate.getDate())} ${months[deliveryDate.getMonth()]}`;
    
      if (hoursLeft >= 24) {
        countdownElements.timeDisplay.style.display = 'none';
        countdownElements.soonDisplay.style.display = 'inline';
        countdownElements.byDisplay.style.display = 'none';
      } else {
        countdownElements.timeDisplay.style.display = 'inline';
        countdownElements.soonDisplay.style.display = 'none';
        countdownElements.byDisplay.style.display = 'none';
      }
    };    

    updateCountdown();

    setInterval(updateCountdown, 60000);
  }
}

window.customElements.define('delivery-countdown', DeliveryCountdown);
